import React from 'react';
import { observer } from 'mobx-react';
import { lang } from '@lang/interfaces/lang';
import AuthContainer from '@ui/features/Auth/Auth.container';
import HeaderAuthContainer from '@ui/features/Header-auth/Header-auth.container';
import withPage from '@ui/HOCs/withPage';

interface IProps extends JSX.IntrinsicAttributes {
    lang: lang;
}

const Page: React.FC<IProps> = () => {
    return (
        <>
            <HeaderAuthContainer />
            <AuthContainer />
        </>
    );
};

const WrappedPage = withPage(Page, 'auth__wrap', 'authentication');

const AuthenticationPage = observer(WrappedPage);

export default AuthenticationPage;
